<template>
  <div
    v-if="PREVIEW_VISIBLE"
    class="kd-preview"
  >
  <div
    v-show="!PREVIEW_IMAGES_LOADED"
    class="kd-preview__loading-overlay"
  >
    <div class="sk-rotating-plane"></div>
  </div>
  
    <kd-preview-klappkarte-quer-1
      v-if="FORMAT_ID === 'klappkarte-quer-1-148x105'"
      :images="previewImages"
    ></kd-preview-klappkarte-quer-1>

    <kd-preview-klappkarte-quer-2
      v-if="FORMAT_ID === 'klappkarte-quer-2-148x105'"
      :images="previewImages"
    ></kd-preview-klappkarte-quer-2>

    <kd-preview-klappkarte-hoch
      v-if="FORMAT_ID === 'klappkarte-hoch-105x148'"
      :images="previewImages"
    ></kd-preview-klappkarte-hoch>

    <kd-preview-postkarte-hoch
      v-if="FORMAT_ID === 'postkarte-hoch-105x148'"
      :images="previewImages"
    ></kd-preview-postkarte-hoch>

    <kd-preview-postkarte-quer
      v-if="FORMAT_ID === 'postkarte-quer-148x105'"
      :images="previewImages"
    ></kd-preview-postkarte-quer>

    <kd-preview-visitenkarte-hoch
      v-if="FORMAT_ID === 'visitenkarte-hoch-55x85'"
      :images="previewImages"
    ></kd-preview-visitenkarte-hoch>

    <kd-preview-visitenkarte-quer
      v-if="FORMAT_ID === 'visitenkarte-quer-85x55'"
      :images="previewImages"
    ></kd-preview-visitenkarte-quer>

    <kd-button
      class="kd-preview__close-button"
      text="Vorschau schließen"
      size="big"
      type="secondary"
      @click.native="closePreview"
    ></kd-button>
  </div>  
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import { PREVIEW_IMAGE_FOR_SIDE_WITH_ID } from '@/store/getter-types';

import KdButton from '@/components/KdButton.vue';
import KdPreviewKlappkarteQuer1 from '@/components/KdPreviewKlappkarteQuer1.vue';
import KdPreviewKlappkarteQuer2 from '@/components/KdPreviewKlappkarteQuer2.vue';
import KdPreviewPostkarteHoch from '@/components/KdPreviewPostkarteHoch.vue';
import KdPreviewPostkarteQuer from '@/components/KdPreviewPostkarteQuer.vue';
import KdPreviewKlappkarteHoch from '@/components/KdPreviewKlappkarteHoch.vue';
import KdPreviewVisitenkarteHoch from '@/components/KdPreviewVisitenkarteHoch.vue';
import KdPreviewVisitenkarteQuer from '@/components/KdPreviewVisitenkarteQuer.vue';

import {
  PREVIEW_VISIBLE,
  FORMAT_ID,
  SIDE_IDS,
  PREVIEW_IMAGES_LOADED,
} from '@/store/getter-types';

import {
  SET_PREVIEW_VISIBILITY,
} from '@/store/mutation-types';

export default {
  computed: {
    ...mapGetters([
      PREVIEW_VISIBLE,
      FORMAT_ID,
      SIDE_IDS,
      PREVIEW_IMAGES_LOADED,
      PREVIEW_IMAGE_FOR_SIDE_WITH_ID,
    ]),
    previewImages() {
      if (!this.SIDE_IDS) { return {}; }
      const images = {};
      const that = this;
      this.SIDE_IDS.forEach(function(sideId) {
        images[sideId] = this.fullImageUrl(sideId);
      }.bind(this));
      return images;
    },
  },
  methods: {
    ...mapMutations([
      SET_PREVIEW_VISIBILITY,
    ]),
    closePreview() {
      this.SET_PREVIEW_VISIBILITY(false);
    },
    handleEscapePress(ev) {
      if (ev && ev.key === "Escape") {
        this.closePreview();
      }
    },
    fullImageUrl(sideId) {
      const imageUrl = this.PREVIEW_IMAGE_FOR_SIDE_WITH_ID(sideId);
      const fullUrl = `${process.env.VUE_APP_IMAGE_SERVER}${imageUrl}`;
      return fullUrl;
    },
  },
  created: function () {
    window.addEventListener('keyup', this.closePreview)
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.closePreview)
  },
  components: {
    KdPreviewKlappkarteQuer1,
    KdPreviewKlappkarteQuer2,
    KdPreviewPostkarteHoch,
    KdPreviewPostkarteQuer,
    KdPreviewKlappkarteHoch,
    KdPreviewVisitenkarteHoch,
    KdPreviewVisitenkarteQuer,
    KdButton,
  },
};
</script>

<style lang="scss">
.kd-preview {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 110;
  max-height: 100%;
  overflow: hidden;
  // TODO: Scale to look good and not overflow
  background-color: #F5F5F5;
}

.kd-preview__close-button {
  position: absolute;
  // hach / oppermann-specific: the chat widget is overlaying the buttons, so we need to move them a bit up
  bottom: 40px;
  right: 12px;
  z-index: 1000;
}

.kd-preview__loading-overlay {
  position: absolute;
  background-color: #F5F5F5;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.sk-rotating-plane {
  width: 40px;
  height: 40px;
  background-color: #01A3DF;
  margin: 40px auto;
  -webkit-animation: sk-rotatePlane 1.2s infinite ease-in-out;
          animation: sk-rotatePlane 1.2s infinite ease-in-out; }
@-webkit-keyframes sk-rotatePlane {
  0% {
    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);
            transform: perspective(120px) rotateX(0deg) rotateY(0deg); }
  50% {
    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
            transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg); }
  100% {
    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
            transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg); } }
@keyframes sk-rotatePlane {
  0% {
    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);
            transform: perspective(120px) rotateX(0deg) rotateY(0deg); }
  50% {
    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
            transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg); }
  100% {
    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
            transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg); } }
</style>
